module.exports = __webpack_public_path__ + "img/symbol_0.fbd6afb6.png";